module.exports = __webpack_public_path__ + "static/live-room-5-81648edc1d130455deb1b7abee022dc7.jpg";